import React from "react";
import { useLanguage } from "../../context/LanguageContext";

export default function ProfileSubNavBar({ activeTab, setActiveTab }) {
  // Language support
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  return (
    <div
      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
      className='flex bg-white rounded-xl shadow-lg border border-gray-200 p-[1px] gap-2 profile-sub-nav'
    >
      {isRTL ? (
        // Arabic Layout: Change Password | Documents | Edit Profile
        <>
          {/* Change Password - First in Arabic */}
          <button
            onClick={() => setActiveTab("password")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "password"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.changePassword")}
          </button>

          {/* Documents - Second in Arabic */}
          <button
            onClick={() => setActiveTab("documents")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "documents"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.documents")}
          </button>

          {/* Edit Profile - Third in Arabic */}
          <button
            onClick={() => setActiveTab("edit")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "edit"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.editProfileButton")}
          </button>
        </>
      ) : (
        // English Layout: Edit Profile | Documents | Change Password
        <>
          {/* Edit Profile - First in English (left) */}
          <button
            onClick={() => setActiveTab("edit")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "edit"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.editProfileButton")}
          </button>

          {/* Documents - Second in English (middle) */}
          <button
            onClick={() => setActiveTab("documents")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "documents"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.documents")}
          </button>

          {/* Change Password - Third in English (right) */}
          <button
            onClick={() => setActiveTab("password")}
            className={`flex-1 px-3 py-2 md:px-6 md:py-3 text-center whitespace-nowrap text-sm md:text-base transition-all duration-200 rounded-xl arabic-text ${
              activeTab === "password"
                ? "bg-gradient-to-r from-[#FF4A33] to-[#ffa033] text-white font-semibold shadow-lg"
                : "text-gray-600 hover:text-[#F15A29] hover:bg-orange-100"
            }`}
          >
            {translate("profileSubNav.changePassword")}
          </button>
        </>
      )}
    </div>
  );
}
